module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/c94c209c93442b85b5b14513389433ce.png";